import React from "react"
import { useSiteMetadata } from "@/hooks/use-site-metadata"
import { Script } from "gatsby"
import { useLocation } from "@reach/router"

const SharedHead = ({
  pageContext,
  title,
  description,
  image,
  canonicalUrl = false,
  noIndex = false,
  children,
  appendTitle = true,
}) => {
  const language = pageContext.language
  const {
    title: defaultTitle,
    description: defaultDescription,
    image: defaultImage,
    siteUrl,
    twitterUsername,
  } = useSiteMetadata()

  const { pathname } = useLocation()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: image ? image : `${siteUrl}${defaultImage}`,
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername,
  }

  let canonicalTag
  if (canonicalUrl) {
    canonicalTag = <link rel="canonical" href={`${siteUrl}${canonicalUrl}`} />
  } else {
    canonicalTag = <link rel="canonical" href={seo.url} />
  }

  return (
    <>
      <html lang={language} />
      <title>{`${seo.title}${appendTitle ? " | Capsule CRM" : ""}`}</title>
      <meta name="description" content={seo.description} />

      {/* WT Optimize script */}
      <Script type="text/javascript" src="/wt-optimize.js" />

      <Script
        defer
        async
        type="text/javascript"
        id="mp-loader"
        src="https://tracking.capsulecrm.com/tracker?am=MzA0OTQ%3D"
      />

      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.twitterUsername} />

      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0"
      />

      {noIndex && <meta name="robots" content="noindex" />}

      {canonicalTag}

      {children}
    </>
  )
}

export default SharedHead
